import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    NewsArticleService,
    NewsArticlePopupService,
    NewsArticleComponent,
    NewsArticleDetailComponent,
    NewsArticleDialogComponent,
    NewsArticlePopupComponent,
    NewsArticleDeletePopupComponent,
    NewsArticleDeleteDialogComponent,
    newsArticleRoute,
    newsArticlePopupRoute,
    NewsArticleResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...newsArticleRoute,
    ...newsArticlePopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        NewsArticleComponent,
        NewsArticleDetailComponent,
        NewsArticleDialogComponent,
        NewsArticleDeleteDialogComponent,
        NewsArticlePopupComponent,
        NewsArticleDeletePopupComponent,
    ],
    entryComponents: [
        NewsArticleComponent,
        NewsArticleDialogComponent,
        NewsArticlePopupComponent,
        NewsArticleDeleteDialogComponent,
        NewsArticleDeletePopupComponent,
    ],
    providers: [
        NewsArticleService,
        NewsArticlePopupService,
        NewsArticleResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiNewsArticleModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article.module.ts